import { NgModule, APP_ID, makeStateKey, TransferState, CUSTOM_ELEMENTS_SCHEMA, ENVIRONMENT_INITIALIZER, PLATFORM_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';

// import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppConfigService, IS_SSRENDERED_APP, FeatureDetectionService } from '@citi-gcg-173875/citi-utils';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonwealthHttpModule } from './shared/commonwealth-http/commonwealth-http.module';
import {
    NgxWebstorageModule,
    LocalStorageService,
    SessionStorageService,
  } from 'ngx-webstorage';

import { environment } from  '../environments/environment';

import {  ContentService,
          LanguageToggleService,
          SiteCatalystService,
          popupService,
          windowService,
          GuidService,
          ProfilingService,
          SvcServices,
          DmarService,
          PopupModalService, 
          HoneyPotService,
          CONFIG,
  BackendService,
  CrsFidoService } from './services';
import { WINDOW_PROVIDER } from '@citi-gcg-173875/citi-utils';

import { ChatbotService } from './shared/common-component/service/chatbot.service';
// TO DO - Refactor out once artifactory lib is available

import { CoreModule } from './core/core.module';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { Observable } from 'rxjs';
import { AppServerModule } from './app.server.module';
// import ServerSessionStorageService from '../webserver/server-session-storage.service';
// import { StorageServerServiceFactory } from '../webserver/angular-express-engine';

// const DOM_DATA_KEY = makeStateKey<string>('DomData');
// export function appConfigLoad(
//   appConfigService: AppConfigService,
//   transferState: TransferState
// ) {
//   let domData = {};
//   if (transferState.hasKey(DOM_DATA_KEY)) {
//     domData = transferState.get(DOM_DATA_KEY, '');
//   }
//   const appGlobalConfigData = domData['appGlobalConfigData'];
//   const configData =
//     typeof appGlobalConfigData !== 'undefined'
//       ? appGlobalConfigData
//       : environment;
//       console.log('configData',configData)
//   appConfigService.setAppConfig(configData);
//   return (): Promise<boolean> => {
//     return new Promise((resolve, reject) => {
//       resolve(true);
//     });
//   };
// }

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        // BrowserModule,
        BrowserAnimationsModule,
        // BrowserTransferStateModule,
        // PrebootModule.withConfig({ appRoot: 'app-root' }),
        // AppRoutingModule,
        // ServicesModule.forRoot(),
        CoreModule,
        CommonModule,
        // RoutingModule,
        // MatDialogModule,
        CommonwealthHttpModule,
        HttpClientModule,
        NgxWebstorageModule.forRoot(),
    ],
    exports: [
        BrowserAnimationsModule
    ],
    providers: [
        { provide: APP_ID, useValue: 'SSRContainer' },
        { provide: CONFIG, useValue: { api: environment.api } },
        LocalStorageService,
        SessionStorageService,
        WINDOW_PROVIDER,
        ContentService,
        LanguageToggleService,
        SiteCatalystService,
        popupService,
        windowService,
        GuidService,
        ProfilingService,
        SvcServices,
        DmarService,
        PopupModalService,
        HoneyPotService,
        BackendService,
        ChatbotService,
        CrsFidoService,
        //StorageService,
        FeatureDetectionService,
        AppConfigService,
        // {
        //     provide: ENVIRONMENT_INITIALIZER,
        //     useFactory: appConfigLoad,
        //     deps: [AppConfigService, TransferState],
        //     multi: true
        // },
        // {
        //     provide: IS_SSRENDERED_APP,
        //     useValue: true
        // },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

  constructor(public _appConfigService: AppConfigService, private _router: Router, private _transferState: TransferState) {
		    let domData = {};
        
        const DOM_DATA_KEY = makeStateKey<string>('DomData');

		    if (this._transferState.hasKey(DOM_DATA_KEY)) {
          let blank_obj:any = {};
	          domData = this._transferState.get(DOM_DATA_KEY, blank_obj);
	      }

	      let appGlobalConfigData = domData['appGlobalConfigData'];

		    let configData = (typeof appGlobalConfigData !== 'undefined') ? appGlobalConfigData : environment;
        this._appConfigService.setAppConfig(configData);
        let api = this._appConfigService.getConfig('api');

	      let currentRoute = domData['currentRoute'];
	      if (typeof currentRoute !== "undefined"){
			      this._router.navigateByUrl(currentRoute);
    }
	}
}
